import React from "react";
import { LeftOutlined } from "@ant-design/icons";
import { Button, Empty, Typography } from "antd";
import MY_DEVICES from "./constants";
import useMyDevices from "./hooks/useMyDevices";
import { MyDevicesProps } from "./types";
import { getOrderStage } from "./utils/orderStage";
import ActivationModal from "./components/ActivationModal";
import DeviceCard from "./components/DeviceCard";
import FilterTabs from "./components/FilterTabs";
import SkeletonGrid from "./components/SkeletonGrid";
import "./index.scss";

export type { DeviceOrder } from "./types";
export type { MyDevicesProps } from "./types";

const { Title } = Typography;

const MyDevices: React.FC<MyDevicesProps> = ({
  orders,
  ordersLoading,
  focusOrderId,
  showBack = false,
  onBack,
  onActivateDevice,
}) => {
  const {
    activeFilter,
    activationState,
    submitting,
    activationForm,
    counts,
    filteredOrders,
    setActiveFilter,
    openActivation,
    handleCloseModal,
    handleActivate,
  } = useMyDevices({ orders, onActivateDevice });

  return (
    <div className="my-devices">
      <div className="my-devices-header">
        {showBack && (
          <Button
            type="text"
            className="my-devices-back-btn"
            icon={<LeftOutlined />}
            onClick={onBack}
          />
        )}
        <Title level={3} className="my-devices-title">
          {MY_DEVICES.LABELS.TITLE}
        </Title>
      </div>

      <FilterTabs
        activeFilter={activeFilter}
        counts={counts}
        onFilterChange={setActiveFilter}
      />

      {ordersLoading ? (
        <SkeletonGrid />
      ) : filteredOrders.length === 0 ? (
        <Empty description={MY_DEVICES.LABELS.EMPTY} />
      ) : (
        <div className="my-devices-grid">
          {filteredOrders.map((order) => {
            const stage = getOrderStage(order);
            return (
              <DeviceCard
                key={order.id}
                order={order}
                stage={stage}
                isFocused={focusOrderId === order.id}
                canActivate={stage === "delivered"}
                onActivate={openActivation}
              />
            );
          })}
        </div>
      )}

      <ActivationModal
        activationState={activationState}
        activationForm={activationForm}
        submitting={submitting}
        onClose={handleCloseModal}
        onFinish={handleActivate}
      />
    </div>
  );
};

export default MyDevices;
